import styled from 'styled-components';

export default styled.div`
  position: relative;
  float: none;
  width: 100%;

  margin-bottom: 2.5rem;
  display: inline-block;

  
  ${props => props.thisStyles}

  ${props => props.hidden ? 'display: none' : ''};
`;
